import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GoogleIdentityService } from '../services/identity.service';
import { AdvancedDebugging } from '../utilities';

const OP_NAVIGATE_SIGN_IN = 'app:AuthGuard.navigate.signIn';

@Injectable()
export class AuthGuard implements CanActivate {
	private readonly advancedDebugging = new AdvancedDebugging();

	constructor(private identityService: GoogleIdentityService, private router: Router) {}
	canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		if (this.identityService.getUser === null) {
			void this.router.navigate(['sign-in']).catch(error =>
				this.advancedDebugging.captureError(OP_NAVIGATE_SIGN_IN, error, {
					tags: { operation: OP_NAVIGATE_SIGN_IN },
				}),
			);
		}
		return true;
	}
}
